import React from 'react';
import {Modal, ThemeProvider, ModalWrapper, ModalHeader, ModalContent} from '@workboard/wobo-ui';
import i18next from 'i18next';

import styled from "styled-components"
const StyledModal = styled(Modal)`
  ${ModalWrapper} {
    width: 465px;
  }
  ${ModalHeader} {
    padding: 10px 20px !important;
    h1 {
      font-size: 16px !important;
    }
  }
  ${ModalContent} {
    padding: 10px 20px !important;
    p {
       line-height: 1.5;
       margin: 0;
    }
`;
export default class DeleteCommonModal extends React.Component {
  constructor(props) {
    
    super(props);
    
    this.state = {
      title: typeof this.props.id !== 'undefined' && this.props.id != '' ? this.props.deletefirstTitle : this.props.title,
      deleteContentOne: this.props.deleteContentOne,
      deleteContentSecond: typeof this.props.id !== 'undefined' && this.props.id != '' ? this.props.deletefirstTitle : this.props.deleteContentSecond,
      buttonText: this.props.nestedButton ? this.props.nestedButton : typeof this.props.id !== 'undefined' && this.props.id != '' ? i18next.t('Delete') : this.props.buttonText,
      deleteContentSecondExtra: this.props.deleteContentSecondExtra || '',
      deleteContentSecondNote: this.props.deleteContentSecondNote || '',
    };
    this.cancelDelete = this.cancelDelete.bind(this);
    this.deleteItem = this.deleteItem.bind(this);
  }

  cancelDelete() {
    this.props.exitDeleteModal();
  }

  deleteItem() {
    this.props.deleteItems(this.props.id);
  }

  generateBodyContent = (deleteContentOne, deleteContentTwo) => {
    const { deleteContentBodyText } = this.props;

    if (deleteContentBodyText) {
      return deleteContentBodyText;
    }

    return `${deleteContentOne} ${deleteContentTwo}`;
  }

  render() {
    
    return (
      <ThemeProvider>
        <StyledModal
          className={this.props.rootClassName ? `delete-comment ${this.props.rootClassName}` : 'delete-comment'}
          dismissLabel={i18next.t("Cancel")}
          isDanger
          isOpen={true}
          onDismiss={this.cancelDelete}
          onSubmit={() => this.deleteItem()}
          submitLabel={this.state.buttonText}
          title={this.state.title}
          data-testid="deleteCommentMod"
          style={this.props.style}
          disableScrollLock={this.props.disableScrollLock}
          disableEnforceFocus={this.props.disableEnforceFocus}
        >
          <p>
            {this.generateBodyContent(this.state.deleteContentOne, this.state.deleteContentSecond)} {this.state.deleteContentSecondExtra && <span style={{'color':'#ff5630','fontWeight':'bold'}}>{this.generateBodyContent(this.state.deleteContentSecondExtra, '')}</span> }
            {this.state.deleteContentSecondNote && <div style={{'fontStyle':'italic'}}><br/>{this.generateBodyContent(this.state.deleteContentSecondNote, '')}</div> }
            
          </p>
        </StyledModal>
    </ThemeProvider>
     
    );
  }
}
